<div class="container" *ngIf="copyLoaded">
  <div class="row">
    <div class="col-sm-8 col-sm-offset-2">
      <h3 [innerHTML]="appCopy.panelHeader['thisIsEmbarasingTitle'+selectedLanguage]"></h3>
      <p [innerHTML]="appCopy.panelHeader['thisIsEmbarasingMessage'+selectedLanguage]"></p>
    </div>
  </div>
</div>
